module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/suggestions/suggestions.component.css
// module id = ./src/app/suggestions/suggestions.component.css
// module chunks = main